import AuthService from '../services/auth.service';

const user = JSON.parse(localStorage.getItem('user'));

const initialState = user
  ? {status: {loggedIn: true}, user}
  : {status: {loggedIn: false}, user: null};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, data ) {
      return AuthService.login(data.user, data.resources)
        .then(
          user => {
            commit('loginSuccess', user);
            return Promise.resolve(user);
          },
          error => {
            commit('loginFailure');
            return Promise.reject(error)
          }
        )
    },

    token({ commit }, user ) {
      commit('loginSuccess', user);
    },

    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },

    forgotPassword({commit}, email) {
      return AuthService.forgotPassword(email).then(
        success => {
          commit('forgotSuccess', email);
          return Promise.resolve(success);
        },
        err => {
          commit('forgotFailure', err);
          return Promise.reject(err)
        }
      )
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    forgotSuccess(state, email) {
      state.mail = email;
    },
    forgotFailure(state) {
      state.mail = null;
    }
  }
};
